import { useNode } from "@craftjs/core";
import { CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { applyStyleProps, defaultStyleProps, type ResponsiveStyleProps } from "@/lib/craft/style-props";
import { IconListBlockSettings } from "@/components/craft/settings/IconListBlockSettings";

type IconListBlockProps = {
  items: string[];
  style?: ResponsiveStyleProps;
};

export function IconListBlock({ items = ["Feature one", "Feature two"], style = defaultStyleProps() }: IconListBlockProps) {
  const {
    connectors: { connect, drag },
    selected,
    id,
  } = useNode((node) => ({ selected: node.events.selected, id: node.id }));
  const { style: inlineStyle, className: styleClass } = applyStyleProps(style, "desktop", id);

  return (
    <ul
      ref={(ref) => { if (ref) connect(drag(ref)); }}
      className={cn("my-4 space-y-3", `craft-node-${id}`, styleClass, selected && "outline outline-2 outline-dashed outline-primary/30")}
      style={inlineStyle}
    >
      {items.map((item, i) => (
        <li key={i} className="flex items-start gap-3 text-lg text-foreground/85">
          <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

IconListBlock.craft = {
  displayName: "Icon list",
  props: { items: ["Feature one", "Feature two"], style: defaultStyleProps() },
  rules: { canDrag: () => true },
  related: { settings: IconListBlockSettings },
};
